"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateType = void 0;
var TemplateType;
(function (TemplateType) {
    TemplateType["TEST"] = "TEST";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
//# sourceMappingURL=tpl.js.map